export function activeMenuDropdown() {
  $(document).ready(function () {
    $("#cssmenu li.active").addClass("open").children("ul").show(),
      $("#cssmenu li.has-sub>a").on("click", function () {
        $(this).removeAttr("href");
        var t = $(this).parent("li");
        t.hasClass("open")
          ? (t.removeClass("open"),
            t.find("li").removeClass("open"),
            t.find("ul").slideUp(200))
          : (t.addClass("open"),
            t.children("ul").slideDown(200),
            t.siblings("li").children("ul").slideUp(200),
            t.siblings("li").removeClass("open"),
            t.siblings("li").find("li").removeClass("open"),
            t.siblings("li").find("ul").slideUp(200));
      });
  });
  $("#toggle").on("click", function () {
    $("#sidebar").width(),
      0 == $("#sidebar").offset().left
        ? $("#sidebar").animate(
            {
              left: -500,
            },
            { duration: 450 }
          )
        : $("#sidebar").animate(
            {
              left: 0,
            },
            { duration: 450 }
          );
  }),
    $("#toggle_close").on("click", function () {
      $("#sidebar").width(),
        0 == $("#sidebar").offset().left
          ? $("#sidebar").animate(
              {
                left: -500,
              },
              "slow"
            )
          : $("#sidebar").animate(
              {
                left: "0",
              },
              "slow"
            );
    });
}
export function toggleSwitchs() {
  const toggleSwitch = document.querySelector(
      '.theme-switch input[type="checkbox"]'
    ),
    currentTheme = localStorage.getItem("tuneIn_theme");

  function switchTheme(e) {
    e.target.checked
      ? (document.documentElement.setAttribute("tuneIn-theme", "dark"),
        localStorage.setItem("tuneIn_theme", "dark"))
      : (document.documentElement.setAttribute("tuneIn-theme", "white"),
        localStorage.setItem("tuneIn_theme", "white"));
  }
  currentTheme &&
    (document.documentElement.setAttribute("tuneIn-theme", currentTheme),
    "dark" === currentTheme && (toggleSwitch.checked = !0)),
    toggleSwitch.addEventListener("change", switchTheme, !1);
  $(document).ready(function () {
    $(".ms_tranding_more_icon").on("click", function (e) {
      if (
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        void 0 !== $(this).attr("data-other"))
      )
        var t = $(this).parent().parent();
      else t = $(this).parent();
      t.find("ul.tranding_more_option").hasClass("tranding_open_option")
        ? t.find("ul.tranding_more_option").removeClass("tranding_open_option")
        : ($("ul.tranding_more_option.tranding_open_option").removeClass(
            "tranding_open_option"
          ),
          t.find("ul.tranding_more_option").addClass("tranding_open_option"));
    }),
      $(document).on("click", function (e) {
        $("ul.tranding_more_option.tranding_open_option").removeClass(
          "tranding_open_option"
        );
      });
  });
}
export function toggleNavBarLi() {
  $("li.has-sub > ul").on("click", () => {
    $("#sidebar").animate(
      {
        left: -500,
      },
      "slow"
    );
  });
  $("ul.sidebb > li:not(.has-sub)").on("click", () => {
    $("#sidebar").animate(
      {
        left: -500,
      },
      "slow"
    );
    $("li.has-sub > ul").slideUp(200).parents("li").removeClass("open");
  });
}
export function activeNavbar() {
  $("ul.sidebb > li a").each(function () {
    var t = $(this).parent("li");
    t.find("> a").removeClass("active");
    if (this.href == window.location.href) {
      $(this).parents("li").find("> a").addClass("active");
    }
  });
}
export function activeThreeDots() {
  $(".ms_tranding_more_icon").on("click", function (e) {
    if (
      (e.preventDefault(),
      e.stopImmediatePropagation(),
      void 0 !== $(this).attr("data-other"))
    )
      var t = $(this).parent().parent();
    else t = $(this).parent();
    t.find("ul.tranding_more_option").hasClass("tranding_open_option")
      ? t.find("ul.tranding_more_option").removeClass("tranding_open_option")
      : ($("ul.tranding_more_option.tranding_open_option").removeClass(
          "tranding_open_option"
        ),
        t.find("ul.tranding_more_option").addClass("tranding_open_option"));
  }),
    $(document).on("click", function (e) {
      $("ul.tranding_more_option.tranding_open_option").removeClass(
        "tranding_open_option"
      );
    });
}
export function boxed() {
  const currentTheme = localStorage.getItem("currentTheme_f");
  if (currentTheme == 3) {
    document.body.classList.add("index4_body_wrapper");
    document.documentElement.setAttribute("tuneIn-theme", "boxed");
  }
}
export function animationBarOne(x) {
  var elements = document.getElementsByClassName("l-sidebar");
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.width = x;
  }
}
export function toggleNavBarLiFixed() {
  const window_width = $(window).width();
  var elements = document.getElementsByClassName("l-sidebar");
  if (window_width < 1200) {
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.width = "0px";
    }
    $("li.has-sub > ul").on("click", () => {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.width = "0px";
      }
    });
    $("ul.sidebb > li:not(.has-sub)").on("click", () => {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.width = "0px";
      }
    });
  } else {
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.width = "260px";
    }
    $("li.has-sub > ul").on("click", () => {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.width = "260px";
      }
    });
    $("ul.sidebb > li:not(.has-sub)").on("click", () => {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.width = "260px";
      }
    });
  }
}
